export default __webpack_public_path__ + "static/media/030-torch.9a8265b6.png";